import React from 'react';

const TableHeader = ({ 
  key1, 
  zones, 
  doc2Visibility, 
  toggleDoc2Visibility, 
  handleStayCheckedMatched, 
  returnDoc2Zones,
  theadStyle 
}) => {
  const tableId = `zz PNM ${returnDoc2Zones(zones["Zone 1"])} vs. ${returnDoc2Zones(zones["Zone 2"])} ${key1}`;
  
  return (
    <thead>
      <th style={theadStyle}>
        {handleStayCheckedMatched(tableId) ? "Confirmed" : "Potential"} No-Match {returnDoc2Zones(zones["Zone 1"])} vs. {returnDoc2Zones(zones["Zone 2"])}
        
        <div
          style={{
            fontStyle: 'italic',
            fontSize: '13px',
            color: '#526666',
            padding: '2px 0px',
            display: 'inline',
            margin: '2px',
            float: 'right',
            cursor: 'pointer',
          }}
          onClick={() => toggleDoc2Visibility(key1)}
        >
          Expand
          <span
            style={{
              marginLeft: '8px',
              display: 'inline-block',
              width: '0',
              height: '0',
              borderTop: '4px solid transparent',
              borderBottom: '4px solid transparent',
              borderLeft: '8px solid #526666',
              transform: doc2Visibility[key1] ? 'rotate(90deg)' : 'rotate(0deg)',
              transformOrigin: '4px 50%',
              transition: 'transform 0.2s ease',
            }}
          ></span>
        </div>
      </th>
    </thead>
  );
};

export default TableHeader;
